import { render, staticRenderFns } from "./DeduplicateCheck.vue?vue&type=template&id=25379e8d&scoped=true"
import script from "./DeduplicateCheck.vue?vue&type=script&lang=js"
export * from "./DeduplicateCheck.vue?vue&type=script&lang=js"
import style0 from "./DeduplicateCheck.vue?vue&type=style&index=0&id=25379e8d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25379e8d",
  null
  
)

export default component.exports